import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Loader2, LogIn } from "lucide-react";
import { toast } from "sonner";
import { adminLogin } from "../lib/api";
import { BRAND } from "../lib/data";

export default function AdminLogin() {
  const [u, setU] = useState("");
  const [p, setP] = useState("");
  const [loading, setLoading] = useState(false);
  const nav = useNavigate();

  const onSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const { token } = await adminLogin(u, p);
      localStorage.setItem("cc_admin_token", token);
      toast.success("Welcome back!");
      nav("/admin/dashboard");
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Login failed.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-[80vh] flex items-center justify-center container-x section-pad" data-testid="admin-login-page">
      <form onSubmit={onSubmit} className="w-full max-w-md border border-border bg-white p-8 rounded-sm" data-testid="admin-login-form">
        <div className="flex items-center gap-3 mb-6">
          <img src={BRAND.logo} alt="" className="h-12 w-12" />
          <div>
            <div className="font-heading font-extrabold text-navy">Admin Portal</div>
            <div className="text-xs text-muted-foreground">Crew Connect FinInvesto</div>
          </div>
        </div>
        <span className="accent-bar mb-3" />
        <h1 className="font-heading text-2xl font-bold text-navy">Sign In</h1>
        <p className="text-sm text-muted-foreground mt-1">Authorized personnel only.</p>

        <div className="mt-6 space-y-4">
          <div className="flex flex-col gap-1.5">
            <label className="text-xs font-semibold text-navy uppercase tracking-wider">Username</label>
            <input value={u} onChange={(e) => setU(e.target.value)} data-testid="admin-username" className="border border-input bg-white px-3 py-2.5 text-sm rounded-sm focus:outline-none focus:ring-2 focus:ring-navy" />
          </div>
          <div className="flex flex-col gap-1.5">
            <label className="text-xs font-semibold text-navy uppercase tracking-wider">Password</label>
            <input type="password" value={p} onChange={(e) => setP(e.target.value)} data-testid="admin-password" className="border border-input bg-white px-3 py-2.5 text-sm rounded-sm focus:outline-none focus:ring-2 focus:ring-navy" />
          </div>
        </div>

        <button type="submit" disabled={loading} data-testid="admin-login-submit" className="mt-6 w-full bg-brandred hover:bg-brandred-700 text-white py-3 font-semibold rounded-sm flex items-center justify-center gap-2 disabled:opacity-60">
          {loading ? <Loader2 className="animate-spin" size={18} /> : <LogIn size={18} />}
          {loading ? "Signing in..." : "Sign In"}
        </button>
      </form>
    </div>
  );
}
